// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "doctor-schedule-excel" + "." + "b1e1d23e" + ".js";
};